import { fnum } from "../lib/format.js";

/** Download / copy shortcut shown at the foot of a section. */
export function ExportStrip({
  name, count, onExport,
}: {
  name: string; count: number; onExport: (kind: "csv" | "copy") => void;
}) {
  return (
    <div className="sec">
      <div
        className="card card-pad"
        style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}
      >
        <div style={{ flex: 1, minWidth: 220 }}>
          <h3 style={{ fontSize: 13 }}>Export {name} data</h3>
          <p style={{ margin: "3px 0 0", fontSize: 11.5, color: "var(--ink-2)" }}>
            {fnum(count)} filtered records with all status fields &mdash; opens in Excel.
          </p>
        </div>
        <button className="btn btn--primary" type="button" onClick={() => onExport("csv")}>
          Download CSV
        </button>
        <button className="btn" type="button" onClick={() => onExport("copy")}>
          Copy for Excel
        </button>
      </div>
    </div>
  );
}
